@use "../../assets/styles/abstracts/variables" as v;

.appShell {
  width: 100%;
}

// Chinese Brothers page background (Figma Landing 1:6231)
.appShellChineseBrothers {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 120px 15px;
  background-color: v.$navy-dark-color-2;
  background-image: v.$gradient-chinese-brothers-page;
}
